var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import ClusterMap from 'components/Shared/ClusterMap/ClusterMap';
import { useStackableContent } from 'components/Shared/StackedContent/StackableContentContext';
import React, { useMemo, useRef } from 'react';
import useMeasure from 'react-use-measure';
import { useActiveContext } from '../Context/ActiveContext';
import { ProductJourneyPages } from '../pages';
import SidebarSlideController from '../SlideController/SidebarSlideController';
import { Container, MapBoundary } from './styles';
const DesktopProductJourney = (_a) => {
    var { MapComponent } = _a, mapProps = __rest(_a, ["MapComponent"]);
    const { steps } = useActiveContext();
    const scrollRef = useRef();
    const [measureRef, { width }] = useMeasure();
    const { activeStackedContent } = useStackableContent();
    const clusterDetailsMapVisible = useMemo(() => (activeStackedContent === null || activeStackedContent === void 0 ? void 0 : activeStackedContent.id) === ProductJourneyPages.SITE_CLUSTER_OVERVIEW, [activeStackedContent]);
    if (!steps)
        return React.createElement(Container, null);
    return (React.createElement(Container, { ref: scrollRef, style: { paddingLeft: 400 } },
        React.createElement(MapBoundary, { ref: measureRef }, clusterDetailsMapVisible ? (React.createElement(ClusterMap, { width: width })) : (React.createElement(MapComponent, Object.assign({}, mapProps, { width: width })))),
        React.createElement(SidebarSlideController, null)));
};
export default DesktopProductJourney;
